import { render, staticRenderFns } from "./sm-help.vue?vue&type=template&id=3fbd3983&"
import script from "./sm-help.vue?vue&type=script&lang=js&"
export * from "./sm-help.vue?vue&type=script&lang=js&"
import style0 from "./sm-help.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports